import { configureStore } from "@reduxjs/toolkit";
import adminsReducer, { IAdminsState } from "./reducers/adminsReducer";
import authenticatorReducer, { IAuthenticatorState } from "./reducers/authenticatorReducer";
import authReducer, { IAuthState } from "./reducers/authReducer";
import companiesReducer, { ICompaniesState } from "./reducers/companiesReducer";
import customersReducer, { ICustomersState } from "./reducers/customersReducer";
import driversReducer, { IDriversState } from "./reducers/driversReducer";
import imitationsReducer, { IImitationsState } from "./reducers/imitationsReducer";
import menuReducer, { IMenuState } from "./reducers/menuReducer";
import messagesReducer, { IMessagesState } from "./reducers/messagesReducer";
import notificationsReducer, { INotificationsState } from "./reducers/notificationsReducer";
import ordersReducer, { IOrdersState } from "./reducers/ordersReducer";
import paymentsReducer, { IPaymentsState } from "./reducers/paymentsReducer";
import popUpsReducer, { PopUpsState } from "./reducers/popUpsReducer";
import productsCategoriesReducer, { IProductsCategoriesState } from "./reducers/productsCategoriesReducer";
import productsReducer, { IProductsState } from "./reducers/productsReducer";
import profileReducer, { IProfileState } from "./reducers/profileReducer";
import rentalItemsAttachmentsReducer, { IRentalItemsAttachmentsState } from "./reducers/rentalItemsAttachmentsReducer";
import rentalItemsAttachmentsSessionsReducer, { IRentalItemsAttachmentsSessionsState } from "./reducers/rentalItemsAttachmentsSessionsReducer";
import rentalItemsReducer, { IRentalItemsState } from "./reducers/rentalItemsReducer";
import rentalPackagesReducer, { IRentalPackagesState } from "./reducers/rentalPackagesReducer";
import routesReducer, { IRoutesState } from "./reducers/routesReducer";
import servicesReducer, { IServicesState } from "./reducers/servicesReducer";
import servicesResourcesReducer, { IServicesResourcesState } from "./reducers/servicesResourcesReducer";
import sitesReducer, { ISitesState } from "./reducers/sitesReducer";
import staffsReducer, { IStaffsState } from "./reducers/staffsReducer";
import statsReducer, { IStatsState } from "./reducers/statsReducer";
import unitsReducer, { IUnitsState } from "./reducers/unitsReducer";
import usersReducer, { IUsersState } from "./reducers/usersReducer";


export interface IRootReducerT {
    menu: IMenuState;
    users: IUsersState;
    admins: IAdminsState,
    staffs: IStaffsState,
    drivers: IDriversState,
    customers: ICustomersState,
    companies: ICompaniesState,
    sites: ISitesState,
    auth: IAuthState;
    authenticator: IAuthenticatorState;
    popUpsState: PopUpsState;
    profile: IProfileState;
    notifications: INotificationsState;
    routes: IRoutesState;
    products: IProductsState,
    productsCategories: IProductsCategoriesState,
    rentalItems: IRentalItemsState;
    rentalPackages: IRentalPackagesState;
    orders: IOrdersState;
    payments: IPaymentsState;
    units: IUnitsState,
    services: IServicesState,
    servicesResources: IServicesResourcesState;
    rentalItemsAttachments: IRentalItemsAttachmentsState;
    messages: IMessagesState;
    stats: IStatsState;
    rentalItemsAttachmentsSessions: IRentalItemsAttachmentsSessionsState,
    imitations: IImitationsState
}

const reduxStore = configureStore({
    reducer: {
        menu: menuReducer,
        auth: authReducer,
        authenticator: authenticatorReducer,
        users: usersReducer,
        admins: adminsReducer,
        staffs: staffsReducer,
        drivers: driversReducer,
        customers: customersReducer,
        companies: companiesReducer,
        popUpsState: popUpsReducer,
        profile: profileReducer,
        notifications: notificationsReducer,
        routes: routesReducer,
        sites: sitesReducer,
        products: productsReducer,
        productsCategories: productsCategoriesReducer,
        rentalItems: rentalItemsReducer,
        rentalPackages: rentalPackagesReducer,
        orders: ordersReducer,
        payments: paymentsReducer,
        servicesResources: servicesResourcesReducer,
        units: unitsReducer,
        services: servicesReducer,
        rentalItemsAttachments: rentalItemsAttachmentsReducer,
        messages: messagesReducer,
        stats: statsReducer,
        rentalItemsAttachmentsSessions: rentalItemsAttachmentsSessionsReducer,
        imitations: imitationsReducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({
        serializableCheck: false
    }),
});

export default reduxStore;